export const Types = {
    SAVE_LIST_MERCHANT_HNG: 'SAVE_LIST_MERCHANT_HNG',
    SAVE_LIST_USER_MERCHANT_HNG: 'SAVE_LIST_USER_MERCHANT_HNG',
    SAVE_LIST_REQUEST_MERCHANT: 'SAVE_LIST_REQUEST_MERCHANT',
    SAVE_CONFIG_MERCHANT_HNG: 'SAVE_CONFIG_MERCHANT_HNG',
}